import React, { useState, useEffect } from "react";
import propertiesData from "../pages/Properties.json";
import { ArrowBackIos, ArrowForwardIos, Close } from "@mui/icons-material";
import "./Gallery.css"; // Import du fichier CSS

function GalleryTest({property}) {


  const [selectedImage, setSelectedImage] = useState(null); // Image sélectionnée en plein écran
  const [isFullScreen, setIsFullScreen] = useState(false); // Mode plein écran
  const [currentImageIndex, setCurrentImageIndex] = useState(0); // Index de l'image en plein écran

  const handleThumbnailClick = (imgUrl, index) => {
    setSelectedImage(imgUrl);
    setIsFullScreen(true);
    setCurrentImageIndex(index);
  };

  const closeFullScreen = () => {
    setIsFullScreen(false);
  };

  const handlePreviousImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? property.gallery.length - 1 : prevIndex - 1
    );
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === property.gallery.length - 1 ? 0 : prevIndex + 1
    );
  };

  useEffect(() => {
    setSelectedImage(property.gallery[currentImageIndex]);
  }, [currentImageIndex]);

  return (
    <div>
      {!isFullScreen ? (
        <div className="gallery-container">
          <button
            className="gallery-arrow gallery-arrow-left"
            onClick={() => {
              const gallery = document.getElementById("gallery");
              gallery.scrollBy({ left: -300, behavior: "smooth" });
            }}
          >
            <ArrowBackIos className="icon" />
          </button>

          <div id="gallery" className="gallery-images">
            {property.gallery.map((imgUrl, index) => (
              <img
                key={index}
                src={imgUrl}
                alt={`Gallery Image ${index + 1}`}
                className="gallery-thumbnail"
                onClick={() => handleThumbnailClick(imgUrl, index)}
              />
            ))}
          </div>

          <button
            className="gallery-arrow gallery-arrow-right"
            onClick={() => {
              const gallery = document.getElementById("gallery");
              gallery.scrollBy({ left: 300, behavior: "smooth" });
            }}
          >
            <ArrowForwardIos className="icon" />
          </button>
        </div>
      ) : (
        <div className="fullscreen-container">
          <button className="close-button" onClick={closeFullScreen}>
            <Close className="icon" />
          </button>

          <button className="fullscreen-arrow fullscreen-arrow-left" onClick={handlePreviousImage}>
            <ArrowBackIos className="icon-large" />
          </button>

          <img
            src={property.gallery[currentImageIndex]}
            alt="Full-screen"
            className="fullscreen-image"
            onClick={closeFullScreen}
          />

          <button className="fullscreen-arrow fullscreen-arrow-right" onClick={handleNextImage}>
            <ArrowForwardIos className="icon-large" />
          </button>

          <div id="thumbnail-gallery" className="fullscreen-thumbnails">
            {property.gallery.map((imgUrl, index) => (
              <img
                key={index}
                src={imgUrl}
                alt={`Thumbnail ${index + 1}`}
                className={`thumbnail ${
                  currentImageIndex === index ? "thumbnail-active" : ""
                }`}
                onClick={() => setCurrentImageIndex(index)}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default GalleryTest;
